import {BoardObject} from '../board-object.js';
import {Puzzle} from '../puzzle.js';
import {CupcakeGameRules} from '../rules/cupcake-game-rules.js';
import {SpecialPower} from '../special-power.js';

export class FruitAutoExplodePower extends SpecialPower {
    static TypeName = 'fruit-auto-explode-power';
    static InheritProperties = true;

    private exploded: boolean;
    private activating: boolean;
    private boardObject: BoardObject | null = null;

    override activate(puzzle: Puzzle, row: number, column: number): void {
        if (this.exploded) {
            return;
        }

        this.exploded = true;

        puzzle.explode(row, column);
    }

    override loaded(newParent: BoardObject): void {
        this.boardObject = newParent;
        if (!this.activating) {
            this.boardObject.puzzle.registerForActivation(
                this.boardObject.row,
                this.boardObject.column
            );
            this.activating = true;
        }
        // TK: Not my preferred way to do this. When we're adding more moddes and use
        // this component in more places this should be refactored.
        const rules = Puzzle.instance.rules as CupcakeGameRules;
        if (rules) {
            rules.fruitPopped();
        }
        this.boardObject.clickActivated();
    }

    override placed(puzzle: Puzzle, newParent: BoardObject) {
        super.placed(puzzle, newParent);

        // TK: Not my preferred way to do this. When we're adding more moddes and use
        // this component in more places this should be refactored.
        const rules = puzzle.rules as CupcakeGameRules;
        if (rules) {
            rules.fruitPlaced();
        }
    }
}
